export default "__VITE_ASSET__CYRJp_gF__"